/* 外部リンクへアイコンを追加 */
$('.external').each(function(i) {
    $('<a rel="noopener" target="_blank" title="別ウインドウで開きます" style="margin-left: 0.5em;"><img alt="アイコン:別ウインドウ" src="/common/img/external-link-orange-dark03-Shapes4FREE.png"></a>').attr('href',$(this).attr('href')).insertAfter($(this));
});



// WEBPACK FOOTER //
// ./src/external-link.js